import { Link } from 'react-router-dom';
import { getHotMovies } from '@/mocks/movies';
import MovieCard from '@/pages/home/components/MovieCard';

export default function FeaturedGrid() {
  const hotMovies = getHotMovies();

  return (
    <section className="py-10 md:py-14 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex items-center justify-between mb-6 md:mb-8">
          <div>
            <h2 className="font-heading text-xl md:text-3xl font-bold text-foreground-950 mb-2">
              精选推荐
            </h2>
            <p className="text-sm text-foreground-600">编辑团队精心挑选的优质内容</p>
          </div>
          <Link
            to="/category/movie"
            className="hidden sm:flex items-center gap-1.5 text-sm text-primary-500 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap"
          >
            <span>查看更多</span>
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </div>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 md:gap-5">
          {hotMovies.map((movie) => (
            <MovieCard key={movie.id} movie={movie} />
          ))}
        </div>

        <div className="mt-6 text-center sm:hidden">
          <Link
            to="/category/movie"
            className="inline-flex items-center gap-1.5 px-5 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors duration-200"
          >
            <span>查看更多</span>
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}